export const randomToken = () => Math.random().toString(36).slice(2);
